
import {
    SYSTEMDASHBOARDSCREEN_LOAD,

    SYSTEMDASHBOARDSCREEN_SET
} from '../../../actionDefinitions';
import {
    fetchJibeProgressOverTimeStats,
    fetchJibeProgressOverTimeBreakdownStats,

    fetchJibeSessionsOverTimeStats
} from '../../../api/v3/CalibrationV3Api';
import {
    fetchChannels,
    fetchReasonsForContact,
    fetchCalibratedOnSurveyQuestions,
    fetchUserTeamsStats,
    fetchDomainValues
} from '../../../api/v3/DataApi';
import {
    fetchUsersStats
} from '../../../api/v3/SurveyActivityV3Api';
import {
    fetchTicketCountOverTimeStats,
    fetchTicketCountOverTimeBreakdownStats,

    fetchResponseOverTimeStats,
    fetchResponseOverTimeBreakdownStats,

    fetchSystemDashboardReport,

    fetchAlerts,
    _makeAlertSeen
} from '../../../api/v3/SystemDashboardV3Api';

export function loadSystemDashboardBasicData() {
    return dispatch => {
        dispatch(loadReasonsForContact());
        dispatch(loadUserTeamsStats());
        dispatch(loadChannels());
        dispatch(loadCalibratedOnSurveyQuestions());
        dispatch(loadDomainValues());
    };
}

export function loadSystemDashboardOverallScreen(fromDate, toDate, timePeriodicity, selectedFilters) {
    return dispatch => {
        dispatch(loadTicketCountOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters));
        dispatch(loadJibeProgressOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters));
        dispatch(loadResponseOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters));
    };
}

export function loadSystemDashboardBreakdownScreen(pageBreakdown, fromDate, toDate, timePeriodicity, selectedFilters, initSelectedAggregationIdsInLegend) {
    return dispatch => {
        dispatch(loadTicketCountOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, selectedFilters,
            initSelectedAggregationIdsInLegend));
        dispatch(loadJibeProgressOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, selectedFilters));
        dispatch(loadResponseOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, selectedFilters));

    };
}

//Ticket count
export function loadTicketCountOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters) {
    return dispatch =>
        fetchTicketCountOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters)
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { ticketCountOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadTicketCountOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, selectedFilters,
    initSelectedAggregationIdsInLegend) {
    return dispatch =>
        fetchTicketCountOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, selectedFilters)
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { ticketCountOverTimeByBreakdownStats: payload.result } }))
            .then(props => initSelectedAggregationIdsInLegend(props.payload.ticketCountOverTimeByBreakdownStats))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

//Jibe score
export function loadJibeProgressOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters) {
    return dispatch =>
        fetchJibeProgressOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters)
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { jibeProgressOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadJibeProgressOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, selectedFilters) {
    return dispatch =>
        fetchJibeProgressOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, selectedFilters)
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { jibeProgressBreakdownOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

//Jibe Session
export function loadJibeSessionsOverTimeStats(fromDate, toDate, timePeriodicity, teamId) {
    return dispatch =>
        fetchJibeSessionsOverTimeStats(fromDate, toDate, timePeriodicity, teamId)
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { jibeSessionsOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

//Response
export function loadResponseOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters) {
    return dispatch =>
        fetchResponseOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters)
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { responseOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadResponseOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, selectedFilters) {
    return dispatch =>
        fetchResponseOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, selectedFilters)
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { responseBreakdownOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function downloadSystemDashboardReport(fromDate, toDate, timePeriodicity) {
    return dispatch =>
        fetchSystemDashboardReport(fromDate, toDate, timePeriodicity)
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { isDownloadingReport: false } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload: { isDownloadingReport: false } }))
}

export function loadAlerts() {
    return dispatch =>
        fetchAlerts()
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { alerts: payload.result } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadUserTeamsStats() {
    return dispatch =>
        fetchUserTeamsStats()
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { userTeamsStats: payload.result } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadUsersStats() {
    return dispatch =>
        fetchUsersStats()
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { usersStats: payload.result } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadChannels() {
    return dispatch =>
        fetchChannels()
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { channels: payload.result } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadReasonsForContact() {
    return dispatch =>
        fetchReasonsForContact()
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { reasonsForContact: payload.result } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadDomainValues() {
    return dispatch =>
        fetchDomainValues()
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { domainValues: payload.result } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadCalibratedOnSurveyQuestions() {
    return dispatch =>
        fetchCalibratedOnSurveyQuestions()
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: { calibratedOnSurveyQuestions: payload.result } }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function makeAlertSeen(alertId) {
    return dispatch =>
        _makeAlertSeen(alertId)
            .then(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, payload: {} }))
            .catch(payload => dispatch({ type: SYSTEMDASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function updateProps(updatedProps) {
    return dispatch => {
        return dispatch({ type: SYSTEMDASHBOARDSCREEN_SET, updatedProps });
    }
}
